module.exports = __webpack_public_path__ + "0dd18716fb504a0ca6fd4d2812d1d6b4.pdf";